export const locationSettingsKeys = {
	locationSettings: () => ["location-settings"],
	locationSettingsByDomain: (domain: string) => ["location-settings", domain],
};
